import React, { useState, useEffect } from "react";
import { List, ListItem, ListItemIcon, ListItemText, Box, Divider, Typography } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import SpaIcon from "@mui/icons-material/Spa";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupIcon from "@mui/icons-material/Group";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(null);

    // Load user data from local storage
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        setUser(storedUser);
    }, []);

    const menuItems = [
        { text: "Overview", icon: <DashboardIcon />, path: "/dashboard" },
        { text: "Carbon Credits", icon: <SpaIcon />, path: "/carbon-credits" },
        { text: "Performance", icon: <TrendingUpIcon />, path: "/performance" },
        { text: "Legal Compliance", icon: <DescriptionIcon />, path: "/legal" },
    ];

    // Check if user is an admin
    const isAdmin = user?.role === "admin";

    return (
        <Box sx={{ paddingTop: "64px", width: "100%", overflow: "hidden" }}>
            <List sx={{ padding: "10px" }}>
                {/* Main Menu */}
                {menuItems.map((item) => (
                    <ListItem
                        button
                        key={item.text}
                        onClick={() => navigate(item.path)}
                        sx={{
                            cursor: "pointer",
                            backgroundColor: location.pathname === item.path ? "rgba(255, 255, 255, 0.3)" : "transparent",
                            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                            borderRadius: "8px",
                            padding: "10px 15px",
                            margin: "5px 8px",
                        }}
                    >
                        <ListItemIcon sx={{ color: "#ffffff", minWidth: "40px" }}>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                    </ListItem>
                ))}

                {/* Admin Section - Visible Only for Admins */}
                {isAdmin && (
                    <>
                        <Divider sx={{ background: "#FFFFFF", my: 1 }} />
                        <Typography variant="body2" sx={{ px: 2, py: 1, fontWeight: "bold", color: "#A0A0A0" }}>
                            Admin 
                        </Typography>

                        <ListItem
                            button
                            onClick={() => navigate("/admin/users")}
                            sx={{
                                cursor: "pointer",
                                backgroundColor: location.pathname === "/admin/users" ? "rgba(255, 255, 255, 0.3)" : "transparent",
                                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                                borderRadius: "8px",
                                padding: "10px 15px",
                                margin: "5px 8px",
                            }}
                        >
                            <ListItemIcon sx={{ color: "#ffffff", minWidth: "40px" }}>
                                <GroupIcon />
                            </ListItemIcon>
                            <ListItemText primary="User Management" />
                        </ListItem>

                        <ListItem
                            button
                            onClick={() => navigate("/admin/reports")}
                            sx={{
                                cursor: "pointer",
                                backgroundColor: location.pathname === "/admin/reports" ? "rgba(255, 255, 255, 0.3)" : "transparent",
                                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                                borderRadius: "8px",
                                padding: "10px 15px",
                                margin: "5px 8px",
                            }}
                        >
                            <ListItemIcon sx={{ color: "#ffffff", minWidth: "40px" }}>
                                <AdminPanelSettingsIcon />
                            </ListItemIcon>
                            <ListItemText primary="Reports" />
                        </ListItem>
                    </>
                )}
            </List>
        </Box>
    );
};

export default Sidebar;
